"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface WireMeshQuoteCtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
  note: string;
}
const copyData: Record<Lang, WireMeshQuoteCtaCopy> = {
  en: {
    eyebrow: "Wire Diameter & Open Area",
    heading: "Request a Custom Quote Referencing Wire Diameter & Open Area",
    lead: "Submit your required wire diameter, mesh count, aperture size, open area ratio, and stainless steel alloy grade for detailed technical verification and tiered pricing.",
    secondaryLabel: "Technical Resources",
    note: "Manufactured with reference to ISO 9044 and ASTM E2016 standards."
  },
  zh: {
    eyebrow: "丝径与开孔率规格",
    heading: "根据丝径与开孔率要求获取定制报价",
    lead: "提交您所需的金属丝径、目数、网孔尺寸、开孔率指标及合金牌号，由工业技术工程师进行精确选型核算与量产报价。",
    secondaryLabel: "技术资源中心",
    note: "参考 ISO 9044 与 ASTM E2016 标准制造。"
  },
  es: {
    eyebrow: "Diámetro de hilo y área abierta",
    heading: "Solicite presupuesto según diámetro de hilo y porcentaje de área abierta",
    lead: "Indique su diámetro de hilo, número de malla, tamaño de apertura y grado de aleación de acero inoxidable para su verificación técnica y cotización.",
    secondaryLabel: "Recursos técnicos",
    note: "Fabricado con referencia a las normas ISO 9044 y ASTM E2016."
  },
  de: {
    eyebrow: "Drahtdurchmesser & freie Siebfläche",
    heading: "Fordern Sie ein individuelles Angebot nach Drahtdurchmesser und offener Fläche an",
    lead: "Übermitteln Sie Drahtdurchmesser, Maschenzahl, Öffnungsweite, Siebflächenanteil und Edelstahllegierung für eine präzise technische Auslegung.",
    secondaryLabel: "Technische Ressourcen",
    note: "Hergestellt unter Bezugnahme auf ISO 9044 und ASTM E2016."
  },
  fr: {
    eyebrow: "Diamètre de fil et surface ouverte",
    heading: "Demandez un devis sur mesure selon le diamètre de fil et le vide de maille",
    lead: "Transmettez votre diamètre de fil, mesh, ouverture, pourcentage de surface ouverte et nuance d'acier inoxydable pour étude technique et chiffrage.",
    secondaryLabel: "Ressources techniques",
    note: "Fabriqué en référence aux normes ISO 9044 et ASTM E2016."
  },
  pt: {
    eyebrow: "Diâmetro de fio e área aberta",
    heading: "Solicite um orçamento sob medida para diâmetro de fio e área aberta",
    lead: "Envie o diâmetro de fio, contagem de malha, abertura, porcentagem de área aberta e liga de aço inoxidável para validação técnica e cotação.",
    secondaryLabel: "Recursos técnicos",
    note: "Fabricado com referência às normas ISO 9044 e ASTM E2016."
  }
};
export default function WireMeshQuoteCta() {
  const {
    lang
  } = useLanguage();
  const copy = pick(lang, copyData);
  return <CtaBand id="wiremeshquotecta" eyebrow={copy.eyebrow} heading={copy.heading} lead={copy.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: copy.secondaryLabel,
    to: "/TechnicalResourcesPage"
  }} note={copy.note} />;
}